<template>
    <div class="search-bar-component">
        <!-- <h4 class="mb-md-1 font-weight-normal">Sök artikel</h4> -->
        <b-row class="mb-1 mb-md-2">
            <b-col cols="12">
                <!-- basic search -->
                <b-input-group
                    size="lg"
                    class="input-group-merge"
                >
                    <b-input-group-prepend is-text>
                        <feather-icon icon="SearchIcon" />
                    </b-input-group-prepend>
                    <b-form-input v-model="searchQuery" :placeholder="placeholder" />
                </b-input-group>
            </b-col>
        </b-row>
    </div>
</template>

<script>
import {BRow, BCol, BInputGroup, BFormInput, BInputGroupPrepend} from 'bootstrap-vue'

export default {
    name: "SearchBar",
    props: [
        'placeholder'
    ],
    components: {
        BRow,
        BCol,
        BInputGroup,
        BFormInput,
        BInputGroupPrepend
    },
    data() {
        return {
            searchQuery: ''
        }
    },
    watch:{
        searchQuery: function(newVal){
            this.$emit('queryChanged', newVal);
        }    
    }
}
</script>
